import {BaseContainerModel} from '../../base-container.model';
import { bl_inv_txn_sub_line_RowClass} from '../../../dbschema';

export class InventoryTransactionSubLineContainerModel extends BaseContainerModel {
  bl_inv_txn_sub_line: bl_inv_txn_sub_line_RowClass = new bl_inv_txn_sub_line_RowClass();
}